import { useContext, useEffect, useState } from "react";
import React from "react";
import DashboardAPI from "../../api/commercial/dashboard";
import { ErrorContext } from "../../route/error/provider";
import Dashboard from "./index";
import { DashboardModel } from "./types";
import { ProductContext } from "../../context/product-context/productContext";
import {
  BasicAccountApplicationDocument,
  DashboardDocument,
} from "../../api/commercial/generated-types";
import { Params } from "../../api/commercial/url/params";
import { ProductRefType } from "../../context/product-context/types";
import DashboardHelper from "./helper";

export default function DashboardAdapter({
  dashboardDocument,
  addAdditionalCardApplication,
}: {
  dashboardDocument: DashboardDocument;
  addAdditionalCardApplication: (
    basicAccountApplicationRef: string,
    productRef: string,
    companyString: string,
    isSoleProprietorship: boolean,
    hasDecentralizedInvoicing: BasicAccountApplicationDocument["hasDecentralizedInvoicing"],
    limit: number,
  ) => void;
}): React.JSX.Element {
  const { setSelectedProduct, selectedProduct, findPersistedProductByRef } =
    useContext(ProductContext);
  const [dashboardModel, setDashboardModel] = useState<DashboardModel>(null);
  const { setError } = useContext(ErrorContext);

  useEffect(() => {
    const loadedModel: DashboardModel = {
      basicAccountApplications: dashboardDocument.basicAccountApplications,
      cardApplications: dashboardDocument.cardApplications,
    };

    setSelectedProduct(
      findPersistedProductByRef(
        DashboardHelper.getLatestModifiedApplication(dashboardDocument)
          .productRef as ProductRefType,
      ),
    );
    setDashboardModel(loadedModel);
  }, [dashboardDocument, findPersistedProductByRef, setSelectedProduct]);

  return (
    dashboardModel &&
    selectedProduct && (
      <Dashboard
        basicAccountApplications={dashboardModel.basicAccountApplications}
        cardholderApplications={dashboardModel.cardApplications}
        startBasicAccountApplication={async (product: ProductRefType) => {
          try {
            await DashboardAPI.createBasicAccountApplication({
              productRef: product,
            });
          } catch (e) {
            setError(e);
          } finally {
            window.location.replace(Params.productRef.remove());
          }
        }}
        startCardApplication={(
          basicAccountApplicationRef: string,
          productRef: string,
          companyName: string,
          isSoleProprietorship: boolean,
          hasDecentralizedInvoicing: boolean,
          limit: number,
        ) => {
          addAdditionalCardApplication(
            basicAccountApplicationRef,
            productRef,
            companyName,
            isSoleProprietorship,
            hasDecentralizedInvoicing,
            limit,
          );
        }}
      />
    )
  );
}
